const BUILD_MODE = 'build',
      HOME_MODE = 'home',
      EXPLORE_MODE = 'explore',
      DEFAULT_MODE = BUILD_MODE,

      VALID_MODES = [
        BUILD_MODE,
        HOME_MODE
      ];

module.exports = {
  BUILD_MODE,
  EXPLORE_MODE,
  HOME_MODE,
  DEFAULT_MODE,
  VALID_MODES
};
